<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='音视频列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="2">
          <el-button type="primary" @click="showAddDialog">添加音视频</el-button>
        </el-col>
        <el-col :span="6">
          <el-input v-model="param.keywords" placeholder="请输入名称关键字" clearable @clear="search" @keyup.enter.native="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-select v-model="param.type" placeholder="类型" clearable @change="handleTypeChange" style="width: 120px;">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="音频" :value="1"></el-option>
            <el-option label="视频" :value="2"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column label="类型" align="center" width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">音频</span>
            <span v-else-if="scope.row.type === 2">视频</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="名称" align="center">
          <template slot-scope="scope">
            <a v-if="scope.row.url!=''" :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
            <span v-else>{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image v-if="scope.row.pic_url!=''" :src="scope.row.pic_url+'?imageView2/0/h/50'" class="list_img"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="intro" label="简介" align="center"></el-table-column>
        <el-table-column prop="view_count" label="播放量" align="center" width="100px"></el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="success" size="mini" @click="copyUrl(scope.row.url)">复制</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
       :current-page="param.page"
       :page-sizes="[10, 20, 30, 40, 50]"
       :page-size="param.count"
       layout="total, sizes, prev, pager, next, jumper"
       :total="total">
     </el-pagination>
    </el-card>
    <media-add
      :visible="addDialogAvaible"
      :id="currentId"
      @add="addMedia"
      @update="updateMedia"
      @closeDialog="closeAddDialog">
    </media-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import MediaAdd from './MediaAdd.vue'
export default {
  name: 'media_list',
  components: {
    'bread-crumb': BreadCrumb,
    'media-add': MediaAdd
  },
  created () {
    this.param.news_index = process.env.VUE_APP_NEWS_INDEX
    this.getList()
  },
  data () {
    return {
      currentId: 0,
      list: [],
      addDialogAvaible: false,
      total: 0,
      pageTotal: 1,
      param: {
        news_index: 1,
        page: 1,
        count: 10,
        type: 0,
        keywords: ''
      }
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/media/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        // this.$message.error(res.msg)
        this.$message.error('33333')
      }
    },
    async addMedia (data) {
      const res = await this.$http.post('/admin/media/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateMedia (id, data) {
      const res = await this.$http.post('/admin/media/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async copyUrl (text) {
      await navigator.clipboard.writeText(text)
      this.$message.success('复制成功！')
    },
    search () {
      this.param.page = 1
      this.getList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    handleTypeChange (value) {
      if (!value) {
        this.param.type = 0
      }
      this.param.page = 1
      this.getList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/media/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.el-image {
  width: 70px;
}
</style>
